import React from 'react';

const LoadingSpinner = () => {
    return (
        <div data-testid="loading-spinner" style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundColor: '#f8f9fa'
        }}>
            <div style={{
                textAlign: 'center'
            }}>
                <div className="spinner-border text-primary" role="status" style={{
                    width: '3rem',
                    height: '3rem'
                }}>
                    <span className="sr-only" data-testid="loading-spinner-sr-only">Loading...</span>
                </div>
                <p style={{
                    marginTop: '1rem',
                    color: '#6c757d',
                    fontSize: '1.1rem'
                }}>
                    Loading...
                </p>
            </div>
        </div>
    );
};

export default LoadingSpinner;